import { Block } from "common/types/graphql"
import { BlocksRenderer } from "../BlocksRenderer"
import clsx from "classnames"
import type { BodyVariant } from "./node/BodyNode"

export interface BodyProps {
  blocks?: Block[]
  text?: string
  variant: BodyVariant
}

export const LARGE_STYLE =
  "mt-6 first:mt-0 mb-4 text-xl font-medium lg:mt-8 lg:text-2xl font-sans-heading"
export const REGULAR_STYLE = "mb-4 font-serif lg:text-lg"

export const Body = ({ blocks, text, variant }: BodyProps) => (
  <p
    className={clsx({
      [LARGE_STYLE]: variant === "large",
      [REGULAR_STYLE]: variant !== "large", // default to regular
    })}
  >
    {blocks && <BlocksRenderer blocks={blocks} />}
    {text}
  </p>
)
